import { AuthPageLayout } from "@/components/auth-page-layout";
import { RequestPasswordResetForm } from "@/components/request-password-reset-form";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/request-password-reset")({
  component: RequestPasswordResetPage,
});

export default function RequestPasswordResetPage() {
  return (
    <AuthPageLayout>
      <RequestPasswordResetForm />
    </AuthPageLayout>
  );
} 